/* ─────────────────────────────────────────────────────────────
   SUPABASE CLIENT — Single instance for the whole app.
   Import `supabase` from here for all auth and database calls.
   Never initialise a second client anywhere else.
   ───────────────────────────────────────────────────────────── */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    '[supabaseClient] Missing environment variables.\n' +
    'Copy .env.example → .env and fill in your Supabase URL and anon key,\n' +
    'then restart the dev server.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
